module.exports = __webpack_public_path__ + "static/media/exclamation-circle.4c0ed542.svg";